import { CreateTransient, Spinner, Typography } from "../..";
import { Button } from "../button";
import { ComponentPropsWithoutRef } from "react";
import { styled } from "styled-components";

type Props = {
  open: boolean;
  children: string;
  onCancel?: () => void;
  onSave: () => void;
  isLoading?: boolean;
  saveLabel: string;
  cancelLabel: string;
};

const noop = () => {};

export const SaveSnackbar = ({
  children,
  onCancel = noop,
  onSave,
  open,
  isLoading,
  saveLabel,
  cancelLabel,
}: Props) => {
  return (
    <Wrapper $isOpen={open}>
      <Content>
        <Typography variant="body" color="WHITE">
          {children}
        </Typography>
        <StyledButton variant="secondary-small" onClick={onCancel}>
          <Typography variant="body" color="BLACK">
            {cancelLabel}
          </Typography>
        </StyledButton>
        <StyledButton variant="primary" onClick={onSave}>
          <Typography variant="body" color="BLACK">
            {isLoading ? <Spinner size={20} /> : saveLabel}
          </Typography>
        </StyledButton>
      </Content>
    </Wrapper>
  );
};

const Wrapper = styled.div<CreateTransient<{ isOpen: boolean }>>`
  display: flex;
  justify-content: center;
  z-index: 1301;
  position: absolute;
  left: 0;
  right: 0;
  margin: auto;
  display: ${({ $isOpen }) => ($isOpen ? "flex" : "none")};
  flex-direction: column;
  align-items: center;
`;

const Content = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: ${({ theme }) => theme.BORDER_RADIUS.XS};
  min-width: 30px;
  max-width: fit-content;
  padding: ${({ theme }) => theme.PADDING.SM} ${({ theme }) => theme.PADDING.MD};
  font-size: 16px;
  background: ${({ theme }) => theme.COLORS.GRAY_DARK};
  color: ${({ theme }) => theme.COLORS.WHITE};
  gap: ${({ theme }) => theme.SPACING.SM};
`;

const StyledButton = styled(Button)<{
  variant: ComponentPropsWithoutRef<typeof Button>["variant"];
}>`
  height: 36px;
  margin: 0;
`;
